























import TicketTable from "@/components/ticket/TicketTable.vue";
import TabLayout, { ITab } from "@/layouts/TabLayout.vue";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IReference, Reference } from "@/models/reference.entity";
import { IReport } from "@/models/report.entity";
import { ITag } from "@/models/tag.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { TagModule } from "@/store/modules/tag.store";
import { TicketModule } from "@/store/modules/ticket.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";

type ITagTabs = ITab & {
  tag?: ITag;
};

@Component({
  components: {
    TabLayout,
    TicketTable
  },
  filters: {}
})
export default class PartnerReportDetailTicket extends mixins(PermissionMixin) {
  @Ref("ticketTableCard")
  ticketTableCard!: TicketTable;

  @Prop()
  report!: IReport;

  readonly allTab = {
    id: "all",
    value: $t("sign.latest"),
    icon: "mdi-clock-time-nine-outline",
    tag: undefined
  };

  isLoading = false;

  tabs: ITagTabs[] = [];

  activeTab: ITagTabs | null = null;

  get partner() {
    return PartnerModule.partner;
  }

  get ref(): IReference {
    return new Reference({ refId: this.report.id, refType: BackendResourceEnum.REPORT });
  }

  get filters(): IPageFilterElement[] {
    return [
      new PageFilterElement({
        key: "refs.refId",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.ref.refId
      }),
      new PageFilterElement({
        key: "refs.refType",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.ref.refType
      })
    ];
  }

  async mounted() {
    this.activeTab = this.allTab;
    this.isLoading = true;

    TagModule.setFilters([
      new PageFilterElement({
        key: "resources",
        value: BackendResourceEnum.TICKET,
        operation: PageFilterOperationEnum.EQUAL
      })
    ]);
    if (this.can(ActionEnum.READ, BackendResourceEnum.TAG)) {
      await TagModule.fetchFirstPage({
        partnerId: this.report.partnerId
      });
    }

    this.tabs.push(this.allTab);
    for (const tag of TagModule.filteredAndSorted) {
      this.tabs.push({
        id: tag.id,
        value: tag.value,
        icon: tag.icon || "mdi-tag-outline",
        tag
      });
    }

    this.isLoading = false;
  }

  setActiveTab(tab: ITagTabs) {
    this.activeTab = null;
    this.$nextTick(() => {
      this.activeTab = tab;
    });
  }

  async save() {
    await TicketModule.fetchFirstPage({ partnerId: this.report.partnerId });
  }

  openCreateTicket() {
    if (this.ticketTableCard) {
      this.ticketTableCard.openCreateDialog();
    }
  }
}
